import React from 'react';

import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';

import verticalSectionMarkerSet from './constants/verticalSectionMarkerSet';

const VerticalSectionMarker = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          verticalSectionMarkerSet.map((group, i) => (
            <li key={`verticalSectionMarker-showcase-${i}`}>
              <ShowCase codeTemplate={group.codeTemplate}>
                <Preview className={group.previewClass}>
                  {(componentProps) => (
                    group.component(componentProps)
                  )}
                </Preview>
                <Controls optionsGroup={group.optionsGroup} optionsFromState={group.optionsFromState} backgrounds={group.backgrounds} />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default VerticalSectionMarker;


// WEBPACK FOOTER //
// ./src/containers/components/VerticalSectionMarker/VerticalSectionMarker.js